<template>
  <div class="home">
    <header-nav :linkId="activeNum"></header-nav>
    <div class="main">
      <div class="banner">
        <div class="info">
          <h3 class="title">区块链电子发票</h3>
          <p class="desc">区块链发票是由国家税务总局指导、国家税务总局深圳市税务局主导落地，基于区块链技术构建的开票-入账-报销的电子发票新生态。</p>
          <p class="desc">区块链电子发票按需使用，不用定期往返税务部门领购发票，降低了企业办税人员的工作负担，免费用票降低了财务成本，用户购物后自行申请开票，降低了企业的人力投入。</p>
          <div class="btn btn-xm1" @click="handleToMerchant">马上试用</div>
        </div>
    </div>
      <div class="content">
        <h4 class="title">您是否也在为传统发票产生的一系列问题痛苦？</h4>
        <ul class="row1">
          <li class="top">
            <p>申领税盘</p>
            <p>安装统一开票软件</p>
          </li>
          <li class="rt">每月抄报税、清卡</li>
          <li class="bm">
            <p>跑税局票种核定</p>
            <p>每月领购发票</p>
            <p>按领购发票限量开票</p>
          </li>
          <li class="lt">
            <p>办理流程繁琐</p>
            <p>发票限量、限制客户开票</p>
            <p>真假难验、一票多报</p>
          </li>
        </ul>
      </div>

      <div class="content advantage">
        <h4 class="title">区块链电子发票的优势</h4>
        <p class="sub-title">节省成本、提高效率</p>

        <el-row class="row2">
          <el-col :span="12">
            <div class="img">
              <img src="../assets/home/advantage.png" alt="">
            </div>
          </el-col>
          <el-col :span="12">
            <ul class="list">
              <li><span class="num n1">01</span>办税便利</li>
              <li><span class="num n2">02</span>凭证管理</li>
              <li><span class="num n3">03</span>打开融资通路</li>
              <li><span class="num n4">04</span>消费者友好</li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <div class="content">
        <h4 class="title">区块链电子发票解决方案</h4>
        <p class="sub-title">提供多种开票方式，支持多种业务模式，全面满足业务需求</p>
        <div class="row3">
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="8" v-for="item in iconsList" :key="item.id">
              <div class="box" @mouseenter="handleMouseOver(item.id)" @mouseleave="handleMouseout(item.id)" @click="handleProductDesc(item.id)">
                <img :class="{'img-active': item.id == activeIconId}" :src="item.url" alt />
                <div :class="{'hide': item.id == activeIconId}">{{ item.titleTxt }}</div>
                <transition name="el-zoom-in-bottom">
                  <div class="transition-box" v-if="item.id == activeIconId">
                    <span class="title">{{ item.titleTxt }}</span>
                    <p class="desc">{{ item.desc }}</p>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="row3-mobile">
          <ul class="box" v-for="item in iconsList" :key="item.id" @click="handleProductDesc(item.id)">
            <li><img class="img" :src="item.url" alt /></li>
            <li class="info">
              <span class="title">{{ item.titleTxt }}</span>
              <p class="desc">{{ item.desc }}</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="content product-features">
        <h4 class="title">产品特点</h4>
        <p class="sub-title">专业的技术、给你更优质的服务体验</p>
        <div class="row4">
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="12">
              <ul v-for="item in fearuresList" :key="item.id" class="feature-row" >
                <li>
                  <h5 class="feature-title">{{ item.feature }}</h5>
                  <p class="desc">{{ item.desc }}</p>
                </li>
                <li class="icon-box"><img class="img" :src="item.url" /></li>
              </ul>
            </el-col>
            <el-col :span="12" class="product-features-img">
              <img class="img" src="../assets/home/product-features.png" />
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="content partners">
        <h4 class="title">合作伙伴</h4>
        <p class="sub-title">和他们一起使用聚票通</p>
        <ul class="row5">
          <li class="partner" v-for="item in partnerList" :key="item.id">
            <img :class="'img'+item.id" :src="item.url" alt="">
          </li>
        </ul>
        <el-button plain class="btn btn-xm" @click="handleToMerchant">马上试用</el-button>
      </div>

      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import headerNav from '../components/Header.vue'
import Footer from '../components/Footer.vue'
const icon1 = require('@/assets/svg/pay.svg')
const icon2 = require('@/assets/svg/scan-code.svg')
const icon3 = require('@/assets/svg/applets.svg')
const icon4 = require('@/assets/svg/convenience.svg')
const icon5 = require('@/assets/svg/flexibility.svg')
const icon6 = require('@/assets/svg/applicability.svg')
const icon7 = require('@/assets/svg/safety.svg')
const logo1 = require('@/assets/home/partnerLogo/img1.png')
const logo2 = require('@/assets/home/partnerLogo/img2.png')
const logo3 = require('@/assets/home/partnerLogo/img3.png')
const logo4 = require('@/assets/home/partnerLogo/img4.png')
const logo5 = require('@/assets/home/partnerLogo/img5.png')
const logo6 = require('@/assets/home/partnerLogo/img6.png')
const logo7 = require('@/assets/home/partnerLogo/img7.png')
const logo8 = require('@/assets/home/partnerLogo/img8.png')

export default {
  name: 'Home',
  components: {
    headerNav,
    Footer
  },
  data() {
    return {
      activeNum: '1',
      activeIconId: '0',
      actived: false,
      show: false,
      iconsList: [
        {
          id: '1',
          url: icon1,
          titleTxt: '支付开票',
          show: true,
          desc: '支付开票指的是用户在扫码支付后， 在支付成功的页面中直接申请开票， 不用商家任何操作。'
        }, {
          id: '2',
          url: icon2,
          titleTxt: '扫码开票',
          show: false,
          desc: '扫码开票指的是用户在扫描开票二维码之后，提交开票信息，完成开票。'
        }, {
          id: '3',
          url: icon3,
          titleTxt: '商家主动开票',
          show: false,
          desc: '商户通过小程序或网页版后台，主动发起开票。'
        }
      ],
      fearuresList: [
        {
          id: '1',
          feature: '便捷性',
          desc: '手机支付直接开、可存入 微信/支付宝卡包、支持发送到电子邮箱',
          url: icon4
        }, {
          id: '2',
          feature: '灵活性',
          desc: '手机扫码极速开票小程序极速开票、PC端浏览器开票',
          url: icon5
        }, {
          id: '3',
          feature: '适用性',
          desc: '餐饮、零售、批发、 酒店、停车场、生活服务等',
          url: icon6
        }, {
          id: '4',
          feature: '安全性',
          desc: '二维码识别快、准确率高 数据安全可靠、支持按需定制',
          url: icon7
        }
      ],
      partnerList: [
        {
          id: '1',
          url: logo1
        }, {
          id: '2',
          url: logo2
        }, {
          id: '3',
          url: logo3
        }, {
          id: '4',
          url: logo4
        }, {
          id: '5',
          url: logo5
        }, {
          id: '6',
          url: logo6
        }, {
          id: '7',
          url: logo7
        }, {
          id: '8',
          url: logo8
        }
      ]
    }
  },
  methods: {
    handleMouseOver(id) {
      this.activeIconId = id
    },
    handleMouseout(id) {
      this.activeIconId = 0
    },
    handleProductDesc(id) {
      localStorage.setItem('billingType', id)
      this.$router.push('/product')
      window.scrollTo(0, 0)
    },
    handleToMerchant() {
			window.open('https://shanghu.jupiaotong.cn/')
		}
  }
}
</script>

<style lang="less" scoped>
.home {
  .banner {
    width: 100%;
    height: 5.04rem;
    // background: url('~@/assets/home/banner.jpg') no-repeat center 0;
    background-image: url('~@/assets/home/banner.jpg');
    background-position: center 0;
    background-repeat: no-repeat;
    background-size: 100% 5.04rem;
    color: #fff;
    .info {
      margin-left: 18%;
    }
    .title {
      font-size: .3rem;
      font-weight: 100;
      padding: 1.3rem 0 .3rem;
    }
    .desc {
      max-width: 3.72rem;
      font-size: .14rem;
      line-height: .22rem;
    }
    .btn {
      display: inline-block;
      font-size: .18rem;
      margin: .3rem 0;
      padding: .08rem .23rem;
      border: 1px solid #fff;
      border-radius: .04rem;
      &:hover {
        cursor: pointer;
      }
    }
    .btn-xm1 {
      background: 0 0;
      position: relative;
      z-index: 1;
      transition-timing-function: cubic-bezier(.2,1,.3,1);
      transition: border-color .4s,color .4s;
      &::before{
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 4px;
        opacity: 0;
        z-index: -1;
        background: #fff;
        transform: scale3d(.7,1,1);
        transition: transform .4s,opacity .4s;
        transition-timing-function: cubic-bezier(.2,1,.3,1);
      }
      &:hover{
        border-color: transparent;
        color: #333;
        &::before{
          opacity: 1;
          transform: translate3d(0,0,0);
        }
      }
    }
  }
  .main {
    .content {
      max-width: 12rem;
      margin: 100px auto 0;
      text-align: center;
      .title {
        font-size: .3rem;
        color: #333;
        font-weight: 100;
      }
      .sub-title {
        font-size: .14rem;
        color: #999;
        margin-top: .2rem;
      }
      .row1 {
        width: 6.56rem;
        height: 6.35rem;
        margin: .6rem auto 1rem;
        background: url('~@/assets/home/problem.png') no-repeat;
        position: relative;
        font-size: .2rem;
        color: #666;
        li {
          position: absolute;
        }
        .top {
          left: -1.3rem;
          top: .9rem;
          text-align: right;
        }
        .rt {
          right: -.8rem;
          top: .66rem;
        }
        .bm {
          right: -2rem;
          bottom: 1.98rem;
          text-align: left;
        }
        .lt {
          left: -2.4rem;
          bottom: 2.08rem;
          text-align: right;
        }
      }
      .row2 {
        max-width: 12rem;
        margin: .6rem auto 0!important;
        .list {
          font-size: .2rem;
          color: #666;
          text-align: left;
          margin: .34rem 0;
          .num {
            font-size: .6rem;
            font-family: Yuanti SC;
            font-weight: 400;
            font-style: italic;
            margin-right: .58rem;
            width: .8rem;
          }
          li {
            display: flex;
            align-items: center;
            &:not(:last-child) {
              margin-bottom: .1rem;
            }
          }
          .n1 { color: #EC4326; }
          .n2 { color: #F08934; }
          .n3 { color: #FADC4A; }
          .n4 { color: #70DADE; }
        }
      }
      .row3 {
        margin-top: .6rem;
        display: inline-block;
        width: 100%;
        .el-col {
          border: 1px solid #d7d7d7;
          margin: 0 .04rem;
          max-width: 3.8rem;
          padding-bottom: 6%;
          position: relative;
          .box {
            height: 100%;
            font-size: .24rem;
            &:hover {
              cursor: pointer;
            }
          }
          img {
            width: 60%;
            padding-top: .8rem;
          }
          .hide {
            visibility: hidden;
          }
          .img-active {
            width: 57%;
            padding: 0;
          }
          .transition-box {
            width: 100%;
            height: 50%;
            background-color: #B71C22;
            text-align: center;
            color: #fff;
            padding: .3rem .2rem;
            box-sizing: border-box;
            position: absolute;
            bottom: 0;
            .title {
              color: #fff;
              font-size: .24rem;
            }
            .desc {
              font-size: .14rem;
              padding: .2rem 0;
              width: 2.3rem;
              margin: auto;
            }
          }
        }
      }
      .row3-mobile {
        display: none;
      }
      .row4 {
        max-width: 12rem;
        margin: .6rem auto 0;
        .feature-row {
          display: flex;
          justify-content: flex-end;
          .feature-title {
            font-size: .2rem;
            font-weight: 100;
            color: #333;
            text-align: right;
            padding-bottom: .2rem;
          }
          .desc {
            font-size: .14rem;
            color: #666;
            width: 2.65rem;
            text-align: right;
            text-indent: 8em;
            padding-bottom: .6rem;
          }
          .icon-box {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: .38rem;
            width: .84rem;
            height: .84rem;
            border: 1px solid #d7d7d7;
            border-radius: 50%;
            .img {
              width: 50%;
            }
          }
        }
        .product-features-img {
          margin-top: .04rem;
        }
      }
      .row5 {
        display: flex;
        flex-wrap: wrap;
        margin: .6rem 0 1rem;
        .partner {
          width: 2.28rem;
          height: .98rem;
          border-radius: .04rem;
          border: 1px solid #d7d7d7;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          margin: 0 .04rem .12rem;
        }
      }
    }
    .advantage {
      width: 100%;
      max-width: 100%;
      padding: 1rem 0;
      background: #f8f8f8;
    }
    .product-features {
      width: 100%;
      max-width: 100%;
      height: 8.54rem;
      background: rgba(248,248,248,1);
      .title {
        padding-top: 1rem;
      }
    }
    .partners {
      .btn {
        color: #B71C22;
        border: 1px solid #B71C22;
        width: 2rem;
        // height: .6rem;
        font-size: .28rem;
        &:hover{
          border-color: transparent;
          color: #fff;
          &::before{
            opacity: 1;
            transform: translate3d(0,0,0);
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .home {
    .banner {
      // background: url('~@/assets/mobile/home/banner@2x.png') no-repeat center 0;
      background-image: url('~@/assets/home/banner.jpg');
      width: 100%;
      padding: 0;
      box-sizing: border-box;
      background-size: 100% 100%;
      height: 100%;
      .info {
        width: 80%;
        margin: auto;
      }
      .title {
        padding: .3rem 0 .2rem;
        font-size: .34rem;
      }
      .desc {
        font-size: .24rem;
        width: 100%;
        max-width: none;
        line-height: .28rem;
      }
      .btn {
        font-size: .28rem;
        padding: .12rem .2rem .1rem;
      }
    }
    .main {
      .content {
        width: 100%;
        margin: 1rem auto 0;
        .title {
          font-size: .32rem;
        }
        .sub-title {
          font-size: .24rem;
        }
        .row1{
          width: 1.85rem;
          height: 2rem;
          background-size: 100%;
          font-size: .24rem;
          margin: 0.6rem auto 1rem 3rem;
          .top {
            top: 0;
            left: -1.9rem;
          }
          .rt {
            top: .08rem;
            right: -1.8rem;
          }
          .bm {
            bottom: .32rem;
            right: -2.4rem;
          }
          .lt {
            bottom: .26rem;
            left: -2.8rem;
          }
        }
        .row2 {
          width: 100%;
          display: flex;
          align-items: center;
          .el-col-12 {
            display: flex;
            &:first-child {
              justify-content: flex-end;
            }
            &:last-child {
              justify-content: center;
            }
          }
          .img {
            width: 2.6rem;
            img {
              width: 100%;
            }
          }
          .list {
            font-size: .24rem;
            .num {
              font-size: 30px;
              margin-right: .04rem;
              text-align: center;
            }
          }
        }
        .row3 {
          display: none;
        }
        .row3-mobile {
          display: inline-block;
          margin-top: 20px;
          .box {
            display: flex;
            text-align: left;
            background:rgba(255,255,255,1);
            border: 1px solid rgba(215,215,215,1);
            margin: 10px 10px 0;
            height: 1.6rem;
            .title {
              font-size: .3rem;
              color: #333;
              margin-bottom: 4px;
            }
            .desc {
              font-size: .24rem;
              color: #666;
            }
            .img {
              width: 1.4rem;
              height: 1.6rem;
              line-height: 1.6rem;
            }
            .info {
              display: flex;
              justify-content: center;
              flex-direction: column;
              padding-right: 10px;
            }
          }
        }
        .row4 {
          width: 100%;
          margin-top: 40px;
          .feature-row {
            width: 3.8rem;
            margin-left: .14rem;
            .feature-title {
              padding-bottom: .08rem;
              font-size: .28rem;
            }
            .desc {
              padding-bottom: .22rem;
              font-size: .24rem;
            }
            .icon-box {
              width: .5rem;
              height: .5rem;
              margin: 0 .1rem;
              padding: .06rem;
              .img {
                width: .4rem;
                height: .4rem;
              }
            }
            .desc {
              width: 2.8rem;
            }
          }
          .product-features-img {
            display: flex;
            justify-content: center;
            align-items: center;
            .img {
              width: 2.47rem;
            }
          }
        }
        .row5 {
          padding: 0 .02rem;
          .partner {
            width: 31.2%;
            height: .7rem;
            margin: 0 .06rem .12rem;
            .img1, .img2, .img3, .img7 {
              width: 80%;
            }
            .img4, .img5, .img6, .img8 {
              height: 80%;
            }
          }
        }
        .btn {
          height: .6rem;
          line-height: .65rem;
          padding: 0;
        }
      }
      .product-features {
        height: 100%;
        padding-bottom: 60px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue